import { z } from "zod";
import { emailSchema } from "./common";

/**
 * Creates a Zod schema for validating add card form.
 * @param {boolean} isEditMode - Whether the form is in edit mode (only validates city, state, country)
 * @returns {z.ZodObject} Validation schema for the add card form.
 */
export const createAddCardSchema = (isEditMode = false) => {
  if (isEditMode) {
    return z.object({
      city: z.string().min(1, "City is required").trim(),
      state: z.string().min(1, "State is required").trim(),
      country: z.string().min(1, "Please select a country"),
    });
  }

  return z.object({
    firstName: z.string().min(1, "First name is required").trim(),
    lastName: z.string().min(1, "Last name is required").trim(),
    nameOnCard: z.string().min(1, "Name on card is required").trim(),
    email: emailSchema,
    address1: z.string().min(1, "Address is required").trim(),
    city: z.string().min(1, "City is required").trim(),
    state: z.string().min(1, "State is required").trim(),
    zipcode: z
      .string()
      .min(1, "Zip code is required")
      .regex(/^[a-zA-Z0-9\- ]{3,10}$/, "Please enter a valid postal code"),
    country: z.string().min(1, "Please select a country"),
    cardNumber: z
      .string()
      .min(13, "Please enter a valid card number")
      .max(19, "Please enter a valid card number")
      .regex(/^\d+$/, "Card number must contain only digits"),
    expMonth: z
      .string()
      .min(1, "Please enter expiry month")
      .regex(/^(0[1-9]|1[0-2])$/, "Please enter a valid month (MM)"),
    expYear: z
      .string()
      .min(1, "Please enter expiry year")
      .regex(/^\d{4}$/, "Please enter a valid year (YYYY)")
      .refine(
        (year) => parseInt(year) >= new Date().getFullYear(),
        "Please enter a valid year"
      ),
    cvv2: z
      .string()
      .min(3, "Please enter a valid CVV")
      .max(4, "Please enter a valid CVV")
      .regex(/^\d{3,4}$/, "CVV must be 3 or 4 digits"),
    ipAddress: z.string().min(1, "IP address is required"),
  });
};

